import { Component } from "@angular/core"
import { ConfigDefinitions } from "./definitions/types"
import * as moment from "moment"
import { AvailablePostPaths } from "./services/api.service"
import { Modalable } from "./Modalable"

@Component({ template: "" })
export class FollowupsUpdateCommons extends Modalable {
	modalTitleLang: string = "followups"
	modalWidth: string = "modal-full-width"

	data: any = null //will hold the data returning from the api call
	objectCollection: any[] = []
	objectCollectionShown: any[] = []
	patient: any = null
	patient_id: number = null
	message: string = ""
	apiFuncName: AvailablePostPaths
	payors: any[] = []
	isManualChargeShown: string = "no"

	sortField: string = "date"
	sortIsAsc: boolean = false
	enable_invoice_number_edit: boolean = false
	isFetching: boolean = false

	getBaseSendObj() {
		return null
	}
	async ngOnInit() {
		//when called to open
		this.isFetching = true
		const res: any = await this.apiService.post(
			this.apiFuncName,
			this.getBaseSendObj()
		)
		this.load(res)
		this.isFetching = false
	}
	load(res: any) {
		this.objectCollection = res.followups

		const meetingtypes = this.store.getSiteDataTable("meetingtypes")
		const locations = this.store.getSiteDataTable("locations")

		let curDate = null

		this.objectCollection.forEach((followup) => {
			const isPatient = followup.patient_id
			const person = this.store.searchSiteDataItem(
				followup[isPatient ? "patient_id" : "user_id"],
				[isPatient ? "patients" : "sub_users"]
			)
			followup.patient_name = person?.name || ""
			followup.is_group = person?.is_group || "no"
			followup.charge_mode = person?.charge_mode || "by_participant"

			const meetingtype = meetingtypes.find(
				(it) => it.id == followup.meetingtype_id
			)
			followup.meetingtype_name = meetingtype?.name || ""
			followup.location_name = ""

			if (followup.series_id) {
				const fus = this.store.data.followupseries.find(
					(fus) => fus.id == followup.series_id
				)
				if (fus) {
					const location = locations.find((it) => it.id == fus.location_id)
					followup.location_name = location?.name || ""
				}
			}
			if (followup.date != curDate) {
				// followup.isNewDate = true;
				curDate = followup.date
			}

			//followup.isNewDate
		})
		let cliniqData = this.store.getCliniqDataOrExit()
		this.isManualChargeShown = cliniqData.show_manual_charge

		this.enable_invoice_number_edit =
			cliniqData?.enable_invoice_number_edit == "yes"

		this.loadObjectCollections()
	}

	loadObjectCollections() {
		const today = moment.utc().format(ConfigDefinitions.momentDateFormat)
		this.objectCollection.forEach((row) => {
			row.dateObj = new Date(row.date)
			row.timeObj = new Date(today + " " + row.time)
			this.store.removeDecItem(row)
		})
		this.objectCollectionShown = [...this.objectCollection]
		this.search()
	}

	getDateTimeSort(a: any, b: any, factor: number) {
		if (a.date == b.date) {
			return a.timeObj.getTime() - b.timeObj.getTime()
		} else {
			return (a.dateObj.getTime() - b.dateObj.getTime()) * factor
		}
	}

	sort(fieldName: string, repeatSort: boolean = false) {
		if (!repeatSort) {
			this.searchSortService.updateSortField(this, fieldName)
		}

		const reverseFactor = this.sortIsAsc ? 1 : -1

		this.objectCollectionShown.sort((a, b) => {
			if (fieldName == "date") {
				return this.getDateTimeSort(a, b, reverseFactor)
				// if (a.date == b.date) {
				// 	return (a.timeObj.getTime() - b.timeObj.getTime());
				// }
				// else {
				// 	return (a.dateObj.getTime() - b.dateObj.getTime()) * reverseFactor;
				// }
			} else {
				let aVal = String(a[fieldName]) || ""
				let bVal = String(b[fieldName]) || ""
				if (aVal.toLowerCase() == bVal.toLowerCase()) {
					return this.getDateTimeSort(a, b, -1)
				} else {
					return (
						(aVal.toLowerCase() > bVal.toLowerCase() ? 1 : -1) * reverseFactor
					)
				}
			}
		})

		let curDate = null
		this.objectCollectionShown.forEach((row) => {
			row.isNewDate = false
			if (fieldName == "date" && row.date != curDate) {
				row.isNewDate = true
				curDate = row.date
			}
		})

		// this.searchSortService.sort(this, 'objectCollectionShown', fieldName, repeatSort);
	}
	search() {
		this.sort(this.sortField, true)
	}
	choosePatient(obj: any = null) {
		this.objectCollectionShown = [...this.objectCollection]

		this.patient_id = obj?.id
		this.filterByPatient()
		this.sort(this.sortField, true)
	}
	filterByPatient() {
		if (this.patient_id) {
			this.objectCollectionShown = this.objectCollectionShown.filter(
				(row) => row.patient_id == this.patient_id
			)
		}
	}
	saveFollowup(row: any) {}

	updCharged(row: any) {
		if (row.charged == "yes") {
			const fus = this.store.data.followupseries.find(
				(f) => f.id == row.series_id
			)
			if (fus) {
				row.price = fus.price
				//	row.sub_user_tarif=fus.sub_user_tarif;
			}
		}
		this.saveFollowup(row)
	}
}
